import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ImageSpecs = ({ action }) => {
  const Specs = () => {
    if (action === 'scroller') {
      return (
        <span className="spec-container">
          <p className="spec-label">Recommended ratio: </p>&nbsp;
          <p className="spec-value">1:3</p>
        </span>
      );
    } else if (action === 'banner') {
      return (
        <span className="spec-container">
          <p className="spec-label">Required size:</p>
          <p className="spec-value">300x250 pixels</p>
        </span>
      );
    } else {
      return (
        <Fragment>
          <span className="spec-container">
            <p className="spec-label">Required minimum size:</p>
            <p className="spec-value">320x180 pixels</p>
          </span>

          <span className="spec-container">
            <p className="spec-label">Recommended size:</p>
            <p className="spec-value">1000x750px</p>
          </span>
          <span className="spec-container">
            <p className="spec-label">Maximum file size:</p>
            <p className="spec-value">10MB</p>
          </span>
        </Fragment>
      );
    }
  };

  return (
    <div className="specs">
      <p className="spec-header">IMAGE SPECIFICATIONS</p>
      <Specs />
    </div>
  );
};

ImageSpecs.propTypes = {
  action: PropTypes.string
};

ImageSpecs.defaultProps = {
  action: ''
};

export default ImageSpecs;
